import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Container, Row, Col, Form, Modal } from 'react-bootstrap';
import SimulatorMotor from './SimulatorMotor';
import { isMobile } from 'react-device-detect';

const SimulatorPopUpFacile = ({
	data,
	setEditModalSimulator,
	simulatorData,
	currentFormValue,
	setCurrentFormValue,
	handelCancel,
	handelCreateLine,
	children,
}) => {
	const scrollViewRef = useRef(null);
	const [scrollHeight, setScrollHeight] = useState(0);

	// Get window height for web
	const getWindowHeight = () => {
		return window.innerHeight;
	};

	useEffect(() => {
		// Initialize scroll height on component mount
		setScrollHeight(getWindowHeight() - 150);

		// Handle window resize
		const handleResize = () => {
			setScrollHeight(getWindowHeight() - 150);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// useEffect(() => {
	// 	var messageBody = document.querySelector('#modelBody');
	// 	messageBody.scrollTop = messageBody.scrollHeight;
	// }, [currentFormValue]);
	console.log('currentFormValue * * * * *', currentFormValue);
	return (
		<Modal
			show={true}
			onHide={() => {
				setEditModalSimulator(false);
				setCurrentFormValue({});
			}}
			fullscreen={!!isMobile}
			scrollable
			size='xl'
			>
			<Modal.Header
				closeButton
				className='bg-white border-bottom pt-4 pb-3 d-flex justify-content-between align-items-start'
				onHide={() => {
					setEditModalSimulator(false);
					setCurrentFormValue({});
				}}></Modal.Header>

			<Modal.Body>
				{/* <div
					ref={scrollViewRef}
					// onLoad={handleScrollViewLayout}
					style={styles.scrollContainer}> 
				*/}
				<SimulatorMotor
					currentFormValue={currentFormValue}
					setCurrentFormValue={setCurrentFormValue}
					simulatorData={simulatorData}
					// scrollToBottom={scrollToBottom}
				/>

				{/* </div> */}
			</Modal.Body>
			<Modal.Footer>
				<Row className='mt-3'>
					<Col>{children}</Col>
				</Row>
			</Modal.Footer>
		</Modal>
	);
};

SimulatorPopUpFacile.propTypes = {
	setEditModalSimulator: PropTypes.func.isRequired,
	data: PropTypes.object.isRequired,
	simulatorData: PropTypes.object,
	currentFormValue: PropTypes.object,
	setCurrentFormValue: PropTypes.func,
	handelCancel: PropTypes.func,
	handelCreateLine: PropTypes.func,
	children: PropTypes.node,
};

export default SimulatorPopUpFacile;
